import {styled} from '@mui/material'
import {Images, Texts} from 'appearance'
import Button from 'components/Control/Button'
import {useDeviceDetect} from 'services/hooks'
import {useI18n} from 'store/Store'

const RegisterSuccess = ({onDone}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    return (
        <Container isMobile={isMobile}>
            <Title>{i18n.t('register.registerSuccessTitle')}</Title>
            <ImageContainer>
                <Image src={Images.REGISTER_SUCCESS} />
            </ImageContainer>
            <Button
                variant="contained"
                color="secondary"
                style={{width: isMobile ? '100%' : 400}}
                onClick={onDone}>
                {i18n.t('register.loginButton')}
            </Button>
        </Container>
    )
}

export default RegisterSuccess

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    direction: rtl;
    height: 100%;
    padding: ${({isMobile}) => (isMobile ? 20 : 48)}px;
    gap: 48px;
`

const Title = styled(Texts.BoldText)`
    font-size: 30px;
    text-align: right;
    width: 100%;
`

const ImageContainer = styled('div')`
    /* display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex: 1; */
    /* max-width: 20%; */
`

const Image = styled('img')`
    max-width: 100%;
`
